import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuCockpit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.3584 2.78561C11.3326 2.06105 12.6674 2.06105 13.6416 2.78561L19.6416 7.2485C20.3391 7.76734 20.7499 8.58625 20.75 9.45553V18.9995C20.75 20.5183 19.5188 21.7495 18 21.7495H6C4.48122 21.7495 3.25 20.5183 3.25 18.9995V9.45553C3.25009 8.58625 3.66092 7.76734 4.3584 7.2485L10.3584 2.78561ZM12.7461 3.98874C12.3034 3.65966 11.6966 3.65966 11.2539 3.98874L5.25391 8.4526C4.93697 8.68841 4.75009 9.06051 4.75 9.45553V18.9995C4.75 19.6898 5.30965 20.2495 6 20.2495H18C18.6904 20.2495 19.25 19.6898 19.25 18.9995V9.45553C19.2499 9.06051 19.063 8.68841 18.7461 8.4526L12.7461 3.98874Z"
	})
});
export default SvgMenuCockpit;
